export const ARTICLE_BASE_URL = '/article';